import React from 'react';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
}
export function GlassCard({
  children,
  className = ''
}: GlassCardProps) {
  return <div className={`
        glass-panel rounded-2xl p-6 md:p-8
        transition-all duration-300
        hover:bg-white/10 hover:border-white/20 hover:scale-[1.02]
        ${className}
      `} data-id="element-133">
      {children}
    </div>;
}